$(document).on("turbolinks:load", function () {
  let $myModal = $("#tosUpdateModal")
  let $okButton = $("#tosModalOk")
  let $overlay = $(".overlay-background")

  // The partial is only rendered server-side when the user must re-consent, so
  // its presence in the DOM is the signal to show the blocking modal.
  if ($myModal.length) {
    $overlay.css("display", "block")
    $myModal.addClass("show")
    $myModal.css("display", "block")
    $myModal.attr("aria-hidden", false)

    $okButton.on("click", function () {
      $.ajax({
        type: "PATCH",
        url: "/tos_acknowledgement",
        dataType: "json",
        success: function () {
          $myModal.removeClass("show")
          $myModal.css("display", "none")
          $myModal.attr("aria-hidden", true)
          $overlay.css("display", "none")
        },
      })
    })
  }
})
